import React, { useState, useEffect, useContext } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import styles from "./Forgot.module.css";
import { useNavigate } from "react-router-dom";
import sideImage from "../../src/assets/img/login/sky-home.svg";
import Loading from "../General/Loading";
import logo from "../assets/img/logos/sky-new-2020-seeklogo2.svg";

import { ConsultaWS, ConsultaWSGet } from "../Commons/ServiciosBase";

import {
  RecuperarPassword_Respuesta,
  RecuperarPasswordRest_Parametros,
  RecuperarPassword_Entrada,
  builtRecuperarPasswordInput,
} from "../Commons/Services/RecuperarPasswordRest";

import {
  RecuperarPasswordOKTA_Respuesta,
  RecuperarPasswordOKTA_Parametros,
  RecuperarPasswordOKTA_Entrada,
  builtRecuperarPasswordOKTAInput,
} from "../Commons/Services/RecuperarPasswordOKTA";
import BarraLoader from "../General/BarraLoader";

import Modal from "react-bootstrap/Modal";
import Stack from "react-bootstrap/Stack";

import CostumerService from "./CostumerService";
export const Forgot = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };
  const [showModule, setShowModule] = useState(true);
  const [errorCredenciales, setErrorCredenciales] = useState(false);
  const [statusError, setStatusError] = useState("OK");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [usuarioPlaceholder, setUsuarioPlaceholder] = useState("");
  const [imagenURI, setImagenURI] = useState(logo);

  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");
  const [status, setStatus] = useState({
    show: false,
    color: "red",
    message: "",
  });
  const [loading, isLoading] = useState(false);

  const [typePwd, setTypePwd] = useState("password");

  const handleShowNumber = () =>
    setTypePwd(typePwd === "password" ? "text" : "password");

  const navigate = useNavigate();

  const doRecuperarPasswordRest = async () => {
    const RecuperarPasswordRegistroDo: RecuperarPassword_Entrada =
      builtRecuperarPasswordInput(`${user}`);

    let par = RecuperarPasswordRest_Parametros(RecuperarPasswordRegistroDo);
    let RecuperarPasswordRespuesta: RecuperarPassword_Respuesta =
      await ConsultaWS(par);

    if (
      RecuperarPasswordRespuesta.EBMHeaderResponse &&
      RecuperarPasswordRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ==
        "ok" &&
      RecuperarPasswordRespuesta.EBMHeaderResponse.ErrorTecnico.code === "ok"
    ) {
      setStatus({ show: false, color: "red", message: "Validando..." });
      isLoading(false);
      setShowModule(!showModule);
    } else {
      setStatusError("ERROR");

      console.error(
        "error actualizando contraseña",
        RecuperarPasswordRespuesta.EBMHeaderResponse
      );
      setErrorCredenciales(true);

      setStatusError("OK");
      setMessage(
        " Error : " + RecuperarPasswordRespuesta.EBMHeaderResponse.ErrorNegocio
      );
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  };

  const doRecuperarPasswordOKTA = async () => {
    const RecuperarPasswordOKTADO: RecuperarPasswordOKTA_Entrada =
      builtRecuperarPasswordOKTAInput(`${user}`);

    let par = RecuperarPasswordOKTA_Parametros(RecuperarPasswordOKTADO);
    let RecuperarPasswordOKTARespuesta: RecuperarPasswordOKTA_Respuesta =
      await ConsultaWS(par);

    if (
      RecuperarPasswordOKTARespuesta.EBMHeaderResponse &&
      RecuperarPasswordOKTARespuesta.EBMHeaderResponse.ErrorNegocio.Estado.toLowerCase() ===
        "ok" &&
      RecuperarPasswordOKTARespuesta.EBMHeaderResponse.ErrorTecnico.code.toLowerCase() ===
        "ok"
    ) {
      setStatus({ show: false, color: "red", message: "Validando..." });
      isLoading(false);
      setShowModule(!showModule);
    } else {
      setStatus({ show: false, color: "red", message: "Validando..." });
      isLoading(false);
      setShowModule(!showModule);
      setStatusError("ERROR");

      setErrorCredenciales(true);

      setStatusError("OK");
      setMessage(
        " Error : " +
          RecuperarPasswordOKTARespuesta.EBMHeaderResponse.ErrorNegocio
            .DescripcionError
      );
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  };

  const handleSubmit = async () => {
    setStatus({ show: false, color: "red", message: "" });

    if (user == "") {
      setStatus({
        show: true,
        color: "red",
        message: "El campo e-mail es obligatorio",
      });
      console.error(status.message);
      return;
    } else {
      setStatus({ show: true, color: "red", message: "Validando..." });
      isLoading(true);
      // doRecuperarPasswordRest();
      doRecuperarPasswordOKTA();
    } //fin de else
  };

  return (
    <>
      <Container className={styles.container}>
        {loading === true ? <BarraLoader /> : <></>}

        <Row className={styles["rowContainer"]}>
          <Col
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
            className={styles["forgotForm"]}
          >
            <Form className={styles.estiloForm}>
              <img src={imagenURI} className={styles.logo} />
              <hr className={styles["line"]} />
              <Container>
                <Row hidden={!showModule}>
                  <h4
                    className={
                      "text-2xl text-center " + styles["textGradient"] + " mb-2"
                    }
                  >
                    <span>Recuperar contraseña</span>
                  </h4>
                  <p className="text-center flex flex-col mb-8 ">
                    <span>
                      Completa tu correo electrónico para recibir una{" "}
                    </span>
                    <span>contraseña temporal para ingresar a tu cuenta</span>
                  </p>
                </Row>
              </Container>

              <Row hidden={showModule}>
                <h4
                  className={
                    "text-2xl text-center " + styles["textGradient"] + " mb-2"
                  }
                >
                  Contraseña enviada
                </h4>
                <p className="text-center flex flex-col mb-8 ">
                  <span>
                    La contraseña temporal le fue enviada a la dirección de
                    correo electrónico registrada, por lo que si esa cuenta de
                    correo ya no está activa, será necesario comunicarse a
                    Servicio a Clientes para solicitar la actualización.{" "}
                  </span>
                </p>
              </Row>
              <Container>
                <Form.Group
                  hidden={!showModule}
                  className={styles.label + " mb-3"}
                  controlId="formBasicEmail"
                >
                  <Form.Label
                    style={{ marginBottom: "0px" }}
                    className={styles.estiloLabels}
                  >
                    E-mail
                  </Form.Label>

                  <Form.Control
                    type="email"
                    placeholder="correo@dominio.com"
                    value={user}
                    className={styles.estiloLabels}
                    onChange={(e) => setUser(e.target.value)}
                  />
                </Form.Group>
              </Container>

              <Row hidden={!showModule}>
                <Col className={styles["buttonContainer"]}>
                  <Button
                    variant="btn btn-primary"
                    className={styles.boton}
                    onClick={handleSubmit}
                  >
                    Enviar e-mail
                  </Button>
                </Col>
              </Row>
              <Row hidden={showModule}>
                <Col className={styles["buttonContainer"]}>
                  <Button
                    variant="btn btn-primary"
                    className={styles.boton}
                    onClick={() => navigate("/login")}
                  >
                    Volver
                  </Button>
                </Col>
              </Row>
              <Row hidden={showModule}>
                <Col className={styles["buttonContainer"]}>
                  <Button
                    variant="btn btn-secondary"
                    className={styles["btn-secondary-sel"]}
                    onClick={handleShow}
                  >
                    Ver contacto de Servicio a Clientes
                  </Button>
                </Col>
              </Row>

              {status.show && (
                <p style={{ color: status.color }}>{status.message}</p>
              )}
            </Form>
          </Col>
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            className={styles["imageContainer"]}
          >
            <img src={sideImage} className={styles["sideImage"]} />
          </Col>
        </Row>
      </Container>

      <Modal
        className={styles.contenedorModal}
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {" "}
        <Modal.Header className="border-0" closeButton></Modal.Header>{" "}
        <Modal.Body>
          <CostumerService />{" "}
        </Modal.Body>
      </Modal>
    </>
  );
};
